module.exports = __webpack_public_path__ + "static/media/journalist.25514dcc.jpg";